import { useTranslation } from 'react-i18next'
import { IProyectos } from '../../../data/data.model'
import './FilterTableRowExpanded.scss'

interface IFilterTableRowExpanded {
  data: IProyectos[]
}

export const FilterTableRowExpanded = ({ data }: IFilterTableRowExpanded) => {
  const { t }: any = useTranslation()
  return (
    <div className="table-row_expanded_container">
      <div className="table-row_table_data_container">
        <table className="responsive-table" cellSpacing="0" cellPadding="0">
          <tr>
            <th style={{ textTransform: 'uppercase' }}>{t('project.country')}</th>
            <th style={{ textTransform: 'uppercase' }}>{t('project.project_name')}</th>
            <th style={{ textTransform: 'uppercase' }}>{t('project.type_of_territory')}</th>
            <th style={{ textTransform: 'uppercase' }}>{t('project.bioma_region')}</th>
            <th style={{ textTransform: 'uppercase' }}>{t('project.amazonia')}</th>
            <th style={{ textTransform: 'uppercase' }}>{t('project.developer')}</th>
            <th style={{ textTransform: 'uppercase' }}>{t('project.auditor')}</th>
            <th style={{ textTransform: 'uppercase' }}>{t('project.certifier')}</th>
          </tr>
          {data.map((item, index) => {
            return (
              <tr key={index}>
                <td>
                  <div className="table-row_expanded_data">
                    {t(`countries.${item.id_pais}`)}
                  </div>
                </td>
                <td>
                  <div className="table-row_expanded_data">
                    {item.nombre_proyecto}
                  </div>
                </td>
                <td>
                  <div className="table-row_expanded_data">
                    {t(`territory_type.${item.id_tipo_territorio}`)}
                  </div>
                </td>
                <td>
                  <div className="table-row_expanded_data">
                    {t(`biomas.${item.id_bioma}`)}
                  </div>
                </td>
                <td>
                  <div className="table-row_expanded_data">
                    {item.amazonia === '1' ? t(`yes`) : t(`no`)}
                  </div>
                </td>
                <td>
                  <div className="table-row_expanded_data">
                    <div key={index} style={{ marginBottom: '5px' }}></div>
                    {item.empresas_desarrolladoras?.map((empresa, index) => {
                      return (
                        <div key={index} style={{ marginBottom: '5px' }}>
                          * {empresa}
                        </div>
                      )
                    })}
                  </div>
                </td>
                {/* <td>{ item.certificador }</td> */}
                {/* <td>{ item.auditor }</td> */}
                <td>
                  <div className="table-row_expanded_data">
                    {item.verificador || t('no_disponible')}
                  </div>
                </td>
                <td>
                  <div className="table-row_expanded_data">
                    {item.estandar_certificacion || t('no_disponible')}
                  </div>
                </td>
              </tr>
            )
          })}
        </table>
      </div>
    </div>
  )
}
